var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.496 39.212l-6.66-7.488 6.66-7.524h2.412l-5.616 6.444h23.112v2.124H22.292l5.616 6.444h-2.412z",
    fill: "#F6F4F4"
  })));
}

var MemoSvgArrowReverse = /*#__PURE__*/React.memo(SvgArrowReverse);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjQ5NiAzOS4yMTJMMTguODM2IDMxLjcyNEwyNS40OTYgMjQuMkgyNy45MDhMMjIuMjkyIDMwLjY0NEw0NS40MDQgMzAuNjQ0VjMyLjc2OEgyMi4yOTJMMjcuOTA4IDM5LjIxMkgyNS40OTZaIiBmaWxsPSIjRjZGNEY0Ii8+Cjwvc3ZnPgo=";
export { MemoSvgArrowReverse as ReactComponent };